import React, { useEffect } from 'react';
import { autoId } from '@workday/upc-common';
import { Select as PreviewSelect } from '@workday/canvas-kit-preview-react/select';
import { useTranslation } from 'react-i18next';
import { useGetAvailableLocalesQuery, useUpdateUserLocaleMutation } from '../../../../slices/account-api.slice';
import styles from './locale-preferences-row.module.scss';
import { LoadingDots } from '@workday/canvas-kit-react';
import { ID_LOCALE_SELECT } from '../../../../autoIds';
import { FormField } from '@workday/canvas-kit-react/form-field';
import { updateLocale } from '../../../../../i18n';
import { localeOptions } from '../../../../shared/locale-selector/localeUtils';
import { RenderSelected } from '../../../../shared/locale-selector/render-selected';
import { RenderOption } from '../../../../shared/locale-selector/render-option';

export function UserLocalePreferencesRow({ userInfo }) {
    const { t } = useTranslation('account');
    const [selectedLocale, setSelectedLocale] = React.useState('');

    // @ts-ignore
    const { data, isLoading } = useGetAvailableLocalesQuery();

    const [updateUserLocale] = useUpdateUserLocaleMutation();

    useEffect(() => {
        if (userInfo.locale) {
            setSelectedLocale(userInfo.locale.toLowerCase());
            updateLocale(userInfo.locale);
        }
    }, [userInfo.locale]);

    const selectLanguage = t('LocalePreferencesRow.selectLanguage');
    const locales = localeOptions(selectLanguage, data);

    const onChange = event => {
        const selectedLocale = locales.filter(v => v.value === event.target.value)[0];
        setSelectedLocale(selectedLocale.value);
        updateUserLocale({ locale: selectedLocale.value });
    };

    return (
        <div className='settingsRow'>
            <h1 className='settingsRow__title'>{t('LocalePreferencesRow.title')}</h1>
            <div className='settingsRow__content'>
                <p>{t('LocalePreferencesRow.description')}</p>
                {isLoading ? (
                    <LoadingDots />
                ) : (
                    <div className={styles.locale}>
                        <FormField
                            label={t('LocalePreferencesRow.preferredLanguage')}
                            labelPosition={FormField.LabelPosition.Left}
                            className={styles.locale__preferredLanguage}>
                            <PreviewSelect
                                {...autoId(ID_LOCALE_SELECT)}
                                onChange={onChange}
                                value={selectedLocale}
                                options={locales}
                                renderOption={RenderOption}
                                renderSelected={RenderSelected}
                            />
                        </FormField>
                    </div>
                )}
            </div>
        </div>
    );
}
